import { Routes } from "@angular/router";
import { loadTranslationResolver } from "@kernel/translations/resolvers/load-translations.resolver";
import { TRANSLATION_PATHS } from "./shared/general/translation/constants/translation.constant";
import { MainLayoutComponent } from "./shared/general/layouts/main-layout/main-layout.component";
import { authGuard } from "./shared/general/guards/auth.guard";

export const routes: Routes = [
  {
    path: "",
    component: MainLayoutComponent,
    canActivate: [authGuard],
    resolve: { transition: loadTranslationResolver(TRANSLATION_PATHS.ROOT) },
    children: [
      {
        path: "",
        loadChildren: () => import("./applications/home/home.routes").then(r => r.homeRoutes),
        pathMatch: "full",
      },
      {
        path: "scm",
        children: [
          {
            path: "subjects",
            loadChildren: () =>
              import("./applications/subjects/domains/subjects/subjects.routes").then(r => r.subjectsRoutes),
          },
          {
            path: "notes",
            loadChildren: () =>
              import("./applications/notes/notes.routes").then(r => r.notesRoutes),
          },
          {
            path: "practices",
            loadChildren: () =>
              import("./applications/pratiche/domains/pratiche/pratiche.routes").then(r => r.praticheRoutes),
          },
          {
            path: "kpi-dashboard",
            loadChildren: () =>
              import("./applications/notes/domains/kpi-dashboard/kpi-dashboard.routes").then(r => r.kpiDashboardRoutes),
          },
          {
            path: "settings",
            children: [
              {
                path: "subject-types",
                loadChildren: () =>
                  import("./applications/subjects/domains/subject-types/subject-types.routes").then(
                    r => r.subjectTypesRoutes
                  ),
              },
              {
                path: "subject-statuses",
                loadChildren: () =>
                  import("./applications/subjects/domains/subject-statuses/subject-statuses.routes").then(
                    r => r.subjectStatusesRoutes
                  ),
              },
              {
                path: "mailing-lists",
                loadChildren: () =>
                  import("./applications/subjects/domains/mailing-lists/mailing-lists.routes").then(
                    r => r.mailingListsRoutes
                  ),
              },
              {
                path: "email-templates",
                loadChildren: () =>
                  import("./applications/subjects/domains/email-templates/email-templates.routes").then(
                    r => r.emailTemplatesRoutes
                  ),
              },
              {
                path: "settori-merceologici",
                loadChildren: () =>
                  import("./applications/subjects/domains/settori-merceologici/settori-merceologici.routes").then(
                    r => r.settoriMerceologiciRoutes
                  ),
              },
              {
                path: "practice-statuses",
                loadChildren: () =>
                  import("./applications/pratiche/domains/pratica-statuses/pratica-statuses.routes").then(
                    r => r.praticaStatusesRoutes
                  ),
              },
              {
                path: "subject-activities",
                loadChildren: () =>
                  import("./applications/notes/domains/subject-activities/subject-activities.routes").then(
                    r => r.subjectActivitiesRoutes
                  ),
              },
              {
                path: "practice-activities",
                loadChildren: () =>
                  import("./applications/notes/domains/practice-activities/practice-activities.routes").then(
                    r => r.practiceActivitiesRoutes
                  ),
              },
              {
                path: "spvs",
                loadChildren: () =>
                  import("./applications/pratiche/domains/spv/spv.routes").then(r => r.spvRoutes),
              },
            ],
          },
        ],
      },
      {
        path: "admin",
        children: [
          {
            path: "users",
            loadChildren: () =>
              import("./applications/users/users.routes").then(r => r.usersRoutes),
          },
          {
            path: "roles",
            loadChildren: () =>
              import("./applications/roles/roles.routes").then(r => r.rolesRoutes),
          },
          {
            path: "settings",
            loadChildren: () =>
              import("./applications/settings/settings.routes").then(r => r.settingsRoutes),
          },
        ],
      },
    ],
  },
  {
    path: "auth",
    loadChildren: () => import("./applications/auth/auth.routes").then(r => r.authRoutes),
  },
  { path: "**", redirectTo: "auth/login", pathMatch: "full" },
];
